import React from "react";
import RepeatableObjectField, {
  type FieldDef,
} from "@components/RepeatableField/RepeatableObjectField";
import type { FormContext } from "@features/port-security/components/SecurityClearence.types.ts";
import { usePortSecurityFormStore } from "@features/port-security/store/usePortSecurityForm.store.ts";
import { useFormattedReference } from "@hooks/useFormattedReference";
import type { Nationality } from "@services/gatepass/types";
import { REFERENCE_DATA_TYPES } from "@services/referenceDataApi";
import { t } from "i18next";
import { FormProvider } from "react-hook-form";
import { useOutletContext } from "react-router-dom";

const BloodRelations: React.FC = () => {
  const { formData } = useOutletContext<FormContext>();
  const { setField } = usePortSecurityFormStore();
  const { options: nationalities } = useFormattedReference<Nationality>(
    REFERENCE_DATA_TYPES.NATIONALITY,
    "bff-gatepass",
  );
  const nationalitiesOptions = nationalities
    .map((nationality) => {
      if (typeof nationality === "object" && nationality !== null && "nationality" in nationality) {
        return {
          value: (nationality as { nationality: string }).nationality,
          label: (nationality as { nationality: string }).nationality,
        };
      }
      return { value: "", label: "" };
    })
    .filter((opt) => !!(opt.value && opt.label))
    .sort((a, b) => a.label.localeCompare(b.label));

  const defs: FieldDef[] = [
    { key: "name", label: t("security-clearance.name"), type: "text", maxChars: 200 },
    { key: "relation", label: t("security-clearance.relation"), type: "text", maxChars: 200 },
    {
      key: "nationality",
      label: t("security-clearance.nationality"),
      type: "autocomplete",
      options: nationalitiesOptions,
    },
    { key: "workPlace", label: t("security-clearance.work-place"), type: "text", maxChars: 200 },
  ];
  return (
    <FormProvider {...formData}>
      <RepeatableObjectField
        name="bloodRelations"
        sectionLabel={t("security-clearance.blood-relations")}
        label={t("security-clearance.blood-relations-entry")}
        fields={defs}
        minItems={1}
        maxItems={3}
        addButtonLabel={t("security-clearance.add-relation")}
        onFieldChange={(_, arr: unknown[]) => {
          setField(
            "bloodRelations",
            arr as { relation: string; name: string; nationality: string; workPlace: string }[],
          );
        }}
        testId="blood-relations"
      />
    </FormProvider>
  );
};

export default BloodRelations;
